import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { useWeb3React } from "@web3-react/core";
import { projectContractsConfig } from "../../contracts/projectContractsConfig";

const AllowClaimingHook = () => {
  const web3 = useWeb3();
  const { account } = useWeb3React();
  const project = localStorage.getItem("project");

  const allowClaimingHook = useCallback(
    async (bool, round, decision, nodeMinerVersion) => {
      try {
        const config = projectContractsConfig.find((p) => p.id === project);

        if (!config) {
          throw new Error(`Project configuration not found for: ${project}`);
        }

        // Get the appropriate claim contract based on version
        let contractConfig;
        if (nodeMinerVersion) {
          if (project === "RAIN" || project === "ASTRANOVA") {
            const versionKey = `claimV${nodeMinerVersion}`;
            contractConfig = config.contracts[versionKey];
          } else if (project === "NODEMINER") {
            const versionKey = `claimV${nodeMinerVersion}`;
            contractConfig = config.contracts[versionKey];
          }

          if (!contractConfig) {
            contractConfig = config.contracts.claim;
          }
        } else {
          contractConfig = config.contracts.claim;
        }

        const contract = contractConfig.contract(contractConfig.address, web3);

        // Handle NODEMINER special case - check endTimes
        if (project === "NODEMINER") {
          const roundEndTime = await contract.methods.endTimes(round).call();
          const currentEpoch = Math.floor(Date.now() / 1000);

          if (currentEpoch > roundEndTime) {
            // console.log("The given time has passed.");
            return true;
          } else {
            // console.log("The given time has not passed yet.");
            return false;
          }
        }

        // Standard isEnabled/enableClaims for other projects
        if (bool) {
          const details = await contract.methods.isEnabled(round).call();
          return details;
        } else {
          const gas = await contract.methods
            .enableClaims(round, decision)
            .estimateGas({ from: account });

          const details = await contract.methods
            .enableClaims(round, decision)
            .send({
              from: account,
              gas,
            });

          return details;
        }
      } catch (error) {
        console.error(`Error in allowClaimingHook for ${project}:`, error);
        throw error;
      }
    },
    [web3, account, project]
  );

  return { allowClaimingHook };
};

export default AllowClaimingHook;
// import { useCallback } from "react";
// import useWeb3 from "../useWeb3";
// import environment from "../../utils/Environment";
// import { getclaimscontract, getScrexClaimsContract } from "../../utils/contractHelpers";
// import { getclaimsnewcontract } from "../../utils/contractHelpers";
// import { getClaimNewLatest } from "../../utils/contractHelpers";
// import {
//   getGemsClaimsContract,
//   getIncentivClaimsContract,
//   getLEIAClaimsContract,
//   getOlympusClaimsContract,
//   getNFAClaimsContract,
//   getAstroNovaClaimsContract,
//   getAstroNovaClaimsV2Contract,
//   getMinersClaimsOldContract,
//   getMinersClaimsContract,
//   getMinersClaimsV2Contract,
//   getRainClaimsContract,
//   getRainClaimsV2Contract,
//   getRainClaimsV3Contract,
//   getMatchainClaimsContract,
//   getLuckifyClaimsContract
// } from "../../utils/contractHelpers";

// import { useWeb3React } from "@web3-react/core";

// const AllowClaimingHook = () => {
//   const web3 = useWeb3();
//   const tokenAddress = environment.Claims;
//   const tokenAddressNew = environment.ClaimsNew;
//   const tokenAddressTomi = environment.claimNewLatest;
//   const GemsContractAddress = environment.GEMSClaim;
//   const IncentivContractAddress = environment.IncentivClaim;
//   const LEIAContractAddress = environment.LEIAClaim;
//   const OlympusContractAddress = environment.OlympusClaim;
//   const NFAContractAddress = environment.NFAClaim;
//   const AstroNovaContractAddress = environment.AstroNovaClaim;
//   const AstroNovaContractAddressV2 = environment.AstroNovaClaimV2;

//   const RainContractAddress = environment.RainClaim;
//   const RainContractAddressV2 = environment.RainClaimV2;
//   const RainContractAddressV3 = environment.RainClaimV3;

//   const MatchainContractAddress = environment.MATCHAINClaim;


//   const MinersContractAddressOld = environment.MinersClaimOld;

//   const MinersContractAddress = environment.MinersClaim;
//   const MinersContractAddressV2 = environment.MinersClaimV2;

//   const { account } = useWeb3React();
//   const contract = getclaimscontract(tokenAddress, web3);
//   const contractNew = getclaimsnewcontract(tokenAddressNew, web3);
//   const contractNewLatest = getClaimNewLatest(tokenAddressTomi, web3);
//   const gemsContract = getGemsClaimsContract(GemsContractAddress, web3);
//   const incentivContract = getIncentivClaimsContract(
//     IncentivContractAddress,
//     web3
//   );
//   const LEIAContract = getLEIAClaimsContract(LEIAContractAddress, web3);
//   const OlympusContract = getOlympusClaimsContract(
//     OlympusContractAddress,
//     web3
//   );
//   const NFAContract = getNFAClaimsContract(NFAContractAddress, web3);
//   const AstroNovaContract = getAstroNovaClaimsContract(
//     AstroNovaContractAddress,
//     web3
//   );

//   const AstroNovaContractV2 = getAstroNovaClaimsV2Contract(
//     AstroNovaContractAddressV2,
//     web3
//   );

//   const RainContract = getRainClaimsContract(RainContractAddress, web3);
//   const RainContractV2 = getRainClaimsV2Contract(RainContractAddressV2, web3);
//   const RainContractV3 = getRainClaimsV3Contract(RainContractAddressV3, web3);

//   const MatchainContract = getMatchainClaimsContract(MatchainContractAddress, web3);
//   const LuckifyContract = getLuckifyClaimsContract(environment.LUCKIFYClaim, web3);

//   const ScrexContract = getScrexClaimsContract(environment.SCREXClaim, web3);
//   const ChainersContract = getScrexClaimsContract(environment.CHAINERSClaim, web3);
//   const MinersContractOld = getMinersClaimsOldContract(
//     MinersContractAddressOld,
//     web3
//   );

//   const MinersContract = getMinersClaimsContract(MinersContractAddress, web3);
//   const MinersContractV2 = getMinersClaimsV2Contract(
//     MinersContractAddressV2,
//     web3
//   );

//   const project = localStorage.getItem("project");
//   const allowClaimingHook = useCallback(
//     async (bool, round, decesion, nodeMinerVersion) => {
//       if (project == "MATCHAIN") {
//         try {
//           if (bool) {
//             const details = await MatchainContract.methods
//               .isEnabled(round)
//               .call();
//             return details;
//           } else {
//             const gas = await MatchainContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await MatchainContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "LUCKIFY") {
//         try {
//           if (bool) {
//             const details = await LuckifyContract.methods
//               .isEnabled(round)
//               .call();
//             return details;
//           } else {
//             const gas = await LuckifyContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await LuckifyContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "SCREX") {
//         try {
//           if (bool) {
//             const details = await ScrexContract.methods
//               .isEnabled(round)
//               .call();
//             return details;
//           } else {
//             const gas = await ScrexContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await ScrexContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "CHAINERS") {
//         try {
//           if (bool) {
//             const details = await ChainersContract.methods
//               .isEnabled(round)
//               .call();
//             return details;
//           } else {
//             const gas = await ChainersContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await ChainersContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "INCENTIV") {
//         try {
//           if (bool) {
//             const details = await incentivContract.methods
//               .isEnabled(round)
//               .call();
//             return details;
//           } else {
//             const gas = await incentivContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await incentivContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "NFA") {
//         try {
//           if (bool) {
//             const details = await NFAContract.methods.isEnabled(round).call();
//             return details;
//           } else {
//             const gas = await NFAContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await NFAContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "NODEMINER") {
//         if (nodeMinerVersion == 1) {
//           try {
//             // console.log(
//               "round in node miner claims status hook: ",
//               round,
//               project
//             );

//             const roundEndTime = await MinersContractOld.methods
//               .endTimes(round)
//               .call();

//             const currentEpoch = Math.floor(Date.now() / 1000);

//             if (currentEpoch > roundEndTime) {
//               // console.log("The given time has passed.");
//               return true;
//             } else {
//               // console.log("The given time has not passed yet.");
//               return false;
//             }
//           } catch (error) {
//             // console.log(error, "errorerrorerrorerrorerror");
//             throw error;
//           }
//         } else if (nodeMinerVersion == 2) {
//           try {
//             const roundEndTime = await MinersContract.methods
//               .endTimes(round)
//               .call();

//             const currentEpoch = Math.floor(Date.now() / 1000);

//             if (currentEpoch > roundEndTime) {
//               // console.log("The given time has passed.");
//               return true;
//             } else {
//               // console.log("The given time has not passed yet.");
//               return false;
//             }
//           } catch (error) {
//             // console.log(error, "errorerrorerrorerrorerror");
//             throw error;
//           }
//         } else {
//           try {
//             const roundEndTime = await MinersContractV2.methods
//               .endTimes(round)
//               .call();

//             const currentEpoch = Math.floor(Date.now() / 1000);

//             if (currentEpoch > roundEndTime) {
//               // console.log("The given time has passed.");
//               return true;
//             } else {
//               // console.log("The given time has not passed yet.");
//               return false;
//             }
//           } catch (error) {
//             // console.log(error, "errorerrorerrorerrorerror");
//             throw error;
//           }
//         }
//       } else if (project == "ASTRANOVA") {
//         if (nodeMinerVersion == 1) {
//           try {
//             if (bool) {
//               const details = await AstroNovaContract.methods
//                 .isEnabled(round)
//                 .call();
//               return details;
//             } else {
//               const gas = await AstroNovaContract.methods
//                 .enableClaims(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await AstroNovaContract.methods
//                 .enableClaims(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 2) {
//           try {
//             if (bool) {
//               const details = await AstroNovaContractV2.methods
//                 .isEnabled(round)
//                 .call();
//               return details;
//             } else {
//               const gas = await AstroNovaContractV2.methods
//                 .enableClaims(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await AstroNovaContractV2.methods
//                 .enableClaims(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         }
//       } else if (project == "RAIN") {
//         if (nodeMinerVersion == 1) {
//           try {
//             if (bool) {
//               const details = await RainContract.methods
//                 .isEnabled(round)
//                 .call();
//               return details;
//             } else {
//               const gas = await RainContract.methods
//                 .enableClaims(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await RainContract.methods
//                 .enableClaims(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 2) {
//           try {
//             if (bool) {
//               const details = await RainContractV2.methods
//                 .isEnabled(round)
//                 .call();
//               return details;
//             } else {
//               const gas = await RainContractV2.methods
//                 .enableClaims(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await RainContractV2.methods
//                 .enableClaims(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 3) {
//           try {
//             if (bool) {
//               const details = await RainContractV3.methods
//                 .isEnabled(round)
//                 .call();
//               return details;
//             } else {
//               const gas = await RainContractV3.methods
//                 .enableClaims(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await RainContractV3.methods
//                 .enableClaims(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         }
//       } else if (project == "LEIA") {
//         try {
//           if (bool) {
//             const details = await LEIAContract.methods.isEnabled(round).call();
//             return details;
//           } else {
//             const gas = await LEIAContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await LEIAContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "OLYMPUS") {
//         try {
//           if (bool) {
//             const details = await OlympusContract.methods
//               .isEnabled(round)
//               .call();
//             return details;
//           } else {
//             const gas = await OlympusContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await OlympusContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "GEMS") {
//         try {
//           if (bool) {
//             const details = await gemsContract.methods.isEnabled(round).call();
//             return details;
//           } else {
//             const gas = await gemsContract.methods
//               .enableClaims(round, decesion)
//               .estimateGas({ from: account });
//             const details = await gemsContract.methods
//               .enableClaims(round, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } catch (error) {
//           throw error;
//         }
//       } else {
//         if (parseInt(round) < 3) {
//           try {
//             if (bool) {
//               const details = await contract.methods.isEnabled(round).call();
//               return details;
//             } else {
//               const gas = await contract.methods
//                 .updateEnable(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await contract.methods
//                 .updateEnable(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         } else if (parseInt(round) > 6) {
//           try {
//             if (bool) {
//               const details = await contractNewLatest.methods
//                 .isEnabled(round)
//                 .call();
//               return details;
//             } else {
//               const gas = await contractNewLatest.methods
//                 .enableClaims(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await contractNewLatest.methods
//                 .enableClaims(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         } else {
//           try {
//             if (bool) {
//               const details = await contractNew.methods.isEnabled(round).call();
//               return details;
//             } else {
//               const gas = await contractNew.methods
//                 .updateEnable(round, decesion)
//                 .estimateGas({ from: account });
//               const details = await contractNew.methods
//                 .updateEnable(round, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } catch (error) {
//             throw error;
//           }
//         }
//       }
//     },
//     [contract]
//   );
//   return { allowClaimingHook: allowClaimingHook };
// };
// export default AllowClaimingHook;
